export const KeySystemStatuses = {
  1: 'In Progress',
  2: 'In Pinning Generation Queue',
  3: 'Offline Pinning Generation In Progress',
  4: 'Offline Pinning Generation Complete',
  5: 'Ready For MECS',
  6: 'In MECS Queue',
  7: 'MECS In Progress',
  8: 'MECS Failed',
  9: 'MECS Completed With Errors',
  10: 'MECS Completed Ready To Publish',
  11: 'In Publishing Queue',
  12: 'Publish Failed',
  13: 'Published',
  14:'In Design',
  15:'Offline Pinning Generation Failed',
  16:'Overtur Bitting Request Failed',
}

export enum KeySystemStatus {
  InProgress = 1,
  InPinningGenerationQueue = 2,
  OfflinePinningGenerationInProgress = 3,
  OfflinePinningGenerationComplete = 4,
  ReadyForMECS = 5,
  InMECSQueue = 6,
  MECSInProgress = 7,
  MECSFailed = 8,
  MECSCompletedWithErrors = 9,
  MECSCompletedReadyToPublish = 10,
  InPublishingQueue = 11,
  PublishFailed = 12,
  Published = 13,
  InDesign=14,
  OfflinePinningGenerationFailed=15,
  OverturBittingRequestFailed=16,
}
